import React, { Component, ReactElement, useState } from "react";

import PageLayout from '../../components/layout/PageLayout'
import { ThemeProps } from "../../components/styles/themeprops";
import { Fade } from "react-awesome-reveal";
import "./impressum.css";
import AccessibilityImg from "./accessibilityImg";
import { handleLogError } from "../../components/misc/Helpers";
import { useTranslation } from "react-i18next";

type Props = { theme: ThemeProps, }
export default function Privacy({ theme }: Props) {


	const { t, i18n } = useTranslation();

	return (
		<PageLayout title="Home" theme={theme}>
			<div className="imprint">
				<div className="basic-projects">
					<Fade direction="left" duration={1000} damping={0.3} triggerOnce={true}>
						<div className="projects-heading-div">
							<div className="imprint-heading-img-div">
								{/* <img
											src={require(`../../assests/images/${projectsHeader["avatar_image_path"]}`)}
											alt=""
										/> */}
								<AccessibilityImg theme={theme} />
							</div>
							<div className="projects-heading-text-div">
								<h1 className="projects-heading-text">{t("accessibility.title")}</h1>
								<p className="projects-header-detail-text subTitle">
									{t("accessibility.description")}
								</p>
							</div>
						</div>
					</Fade>
				</div>
			</div>


			<div className="contact-form-div imprint">
				<h1 className="d-flex justify-content-center">{t("accessibility.title")}</h1>

				<div className="row d-flex align-items-center justify-content-center h-100">
					<div className="col-md-3 col-lg-3 col-xl-3"></div>
					<div className="col-md-6 col-lg-6 col-xl-6 ">
						<div className="float-end"></div>

						<p>
							Diese Erklärung zur Barrierefreiheit gilt für die unter pariyani veröffentlichte Webseite der Materna Information & Communications SE.

							Wir sind bemüht, unsere Websites und mobilen Anwendungen im Einklang mit den Bestimmungen des Behindertengleichstellungsgesetzes des Bundes (BGG) sowie der Barrierefreien-Informationstechnik-Verordnung (BITV 2.0) zur Umsetzung der Richtlinie (EU) 2016/2102 barrierefrei zugänglich zu machen.
						</p>



					</div>
					<div className="col-md-3 col-lg-3 col-xl-3"></div>
				</div>

			</div>

		</PageLayout>
	);
}